let moduleVersion = "3.6.3";
export const getCurrentVersion = () => moduleVersion;
export const setCurrentVersion = version => {
  moduleVersion = version;
};
//# sourceMappingURL=version.js.map